import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Loader from '../../utils/Loader';
import Config from '../../config/Config';
import moment from 'moment';
import { startAttempt } from '../../redux/testPage/testPage.actions';
import {
	fetchAttempt,
	fetchInstruction,
} from '../../redux/myCourse/myCourse.actions';
import { formatDate, formatDateNew, formatDateTime } from '../../utils/commonFunctions';
import { changeActiveCourse } from '../../redux/changeCourse/changeCourse.actions';
import {
	setErrorMsg,
	setShowPermitMic,
} from '../../redux/utilities/utils.actions';
import TestInstruction from '../common/testInstruction';
import { toggleMicPermission } from '../../redux/testPage/testPage.actions';
import ListAnimation from '../utils/animations/list';
import Zoom from '../utils/animations/zoom';
//import setRevealTimer from '../customHooks/RevealTimeHook';
import { minToMs, dateDiff, setRevealTimer } from '../../utils/commonFunctions';

const mapStateToProps = (state) => {
	const { elementId, upnextAll, courseSuccess } = state.rootReducer.myCourse;

	return {
		elementId,
		upnextAll,
		courseSuccess,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		startAttempt: (course_id, elementId) =>
			dispatch(startAttempt({ course_id, elementId })),
		fetchAttempt: (attemptId, review = false) =>
			dispatch(fetchAttempt({ attemptId, review })),
		fetchInstruction: (elementId, courseId, isReview = false) =>
			dispatch(fetchInstruction({ elementId, courseId, isReview })),
		setErrorMsg: (msg) => dispatch(setErrorMsg(msg)),
		changeActiveCourse: (id) => dispatch(changeActiveCourse(id)),
		toggleMicPermission: (val) => dispatch(toggleMicPermission(val)),
		setShowPermitMic: (val) => dispatch(setShowPermitMic(val)),
	};
};

const UpnextList = ({
	setShowPermitMic,
	changeActiveCourse,
	upnextAll,
	fetchAttempt,
	setErrorMsg,
	history,
	toggleMicPermission,
}) => {
	useEffect(() => {
		Loader.hide();
	}, []);

	const UpNextCoach =
		upnextAll.length > 0
			? upnextAll
				?.filter(
					(x) =>
						x.type === 'coach' &&
						(x.calls_completed === 0 || x.calls_completed < x.total_calls),
				)
				?.map((next) => {
					const {
						call_status,
						call_time,
						course_id,
						task_status,
						show_tasks,
					} = next;

					let [startTime, endTime] = call_time?.split('to');

					let displayText = '';
					let button = '';
					let navigateTo = '';
					let footNote = '';
					if (call_time !== '') {
						displayText = 'You have an upcoming call with our coach';
						button = 'View Course';
						navigateTo = `mycourse?course_id=${course_id}`;
						footNote = 'Call on -:-';
					} else if (
						call_status === '' ||
						(call_status === 'Completed' &&
							((show_tasks && task_status === 'Completed') || !show_tasks))
					) {
						displayText = 'Schedule your next Coach Call';
						button = 'Book Call';
						navigateTo = `mycourse?course_id=${course_id}`;
					} else if (
						call_status === 'Completed' &&
						task_status !== 'Completed' &&
						show_tasks
					) {
						displayText = 'Submit your assignment to schedule your next Coach Call';
						button = 'Submit Task';
						navigateTo = '/submitAssignment';
					} else if (call_status === 'InProgress') {
						displayText = `You have an on-going call with our coach now.`;
						button = 'View Course';
						navigateTo = `mycourse?course_id=${course_id}`;
					}

					return (
						<Zoom key={course_id} className="dash-courses">
							<div className="dash-course-logo">
								<img
									src={Config.STORAGEPATH + 'img/courses/' + course_id + '.png'}
									alt="courseimage"
								/>
							</div>
							<div className="dash-course-decs">
								<p>{displayText}</p>
								<div className="dash-course-decs-bottom">
									<a target="_self" href={navigateTo}>
										<button aria-label={button} className="btn btn-primary">
											{button}
										</button>
									</a>
									<p className="dash-decs-date">
										<strong>{footNote} </strong>
										{call_time &&
											`${formatDateNew(startTime, 'DD-MM-yyyy')}, ${formatDateTime(
												startTime,
												'hh:mm A',
											)} to ${formatDateTime(endTime, 'hh:mm A')}`}
									</p>
								</div>
							</div>
						</Zoom>
					);
				})
			: null;

	const UpNextLive =
		upnextAll.length > 0
			? upnextAll
				?.filter((x) => x.type === 'live')
				?.map((next) => {
					const {
						element_name,
						course_id,
						reveal_date,
						element_description,
					} = next;

					return (
						<Zoom key={course_id} className="dash-courses">
							<div className="dash-course-logo">
								<img
									src={Config.STORAGEPATH + 'img/courses/' + course_id + '.png'}
									alt="courseimage"
								/>
							</div>
							<div className="dash-course-decs">
								<p>
									Next LIVE Class on "{`${element_name} - ${element_description}`}"
									coming up
								</p>
								<div className="dash-course-decs-bottom">
									<a target="_self" href={`mycourse?course_id=${course_id}`}>
										<button aria-label="more-info" className="btn btn-primary">
											More Info
										</button>
									</a>
									<p className="dash-decs-date">
										<strong>On</strong> -:- {moment(reveal_date).format('D MMM YYYY')}
									</p>
								</div>
							</div>
						</Zoom>
					);
				})
			: null;

	const UpNextOnline =
		upnextAll.length > 0
			? upnextAll
				?.filter((x) => x.type === 'online')
				?.map((next) => {
					const {
						element_id,
						element_name,
						element_description,
						course_id,
						lock_status,
						lock_message,
						attempt_id,
						element_type,
						progressbar,
						unit_id,

						checkMic,
					} = next;
					let { reveal_date, reveal_time } = next;
					let instructionText = '';
					let instructionLink = {};
					// let reveal_date = '2021-03-11';
					// let reveal_time = '09:34:20';
					const showError = (lock_message) => {
						setErrorMsg(lock_message);
					};

					const handleOnClick = () => {
						// changeActiveCourse(course_id);
						/*history.push(
							`/mycourse?course_id=${course_id}&unit_id=${unit_id}&element_id=${element_id}`,
						);*/
						history.push(
							`/mycourse?course_id=${course_id}`,
						);
					};
					if (!!attempt_id) {
						instructionLink = () => {
							console.log('instructionLink 1')
							fetchAttempt(attempt_id);
						};
					} else if (!!element_type) {
						instructionLink['data-toggle'] = 'modal';
						if (!!lock_status) {
							instructionLink = () => {
								console.log('instructionLink 2')
								showError(lock_message);
							};
						} else {
							instructionLink = () => {
								console.log('instructionLink 3')
								handleOnClick();
							};
							if (element_type === 'W') {
								instructionLink['data-target'] = '#webisode-next-instruction-popup';
							} else if (element_type === 'S') {
								instructionLink['data-target'] =
									'#summativetest-next-instruction-popup';
							} else if (element_type === 'F') {
								instructionLink['data-target'] = '#formative-next-instruction-popup';
							}
						}
					}

					const getPermissions = () => {
						if (!checkMic) {
							instructionLink();
						} else {
							if (navigator.mediaDevices === undefined) {
								navigator.mediaDevices = {};
							}
							if (navigator.mediaDevices.getUserMedia === undefined) {
								navigator.mediaDevices.getUserMedia = function (constraints) {
									var getUserMedia =
										navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

									if (!getUserMedia) {
										return Promise.reject(
											new Error('getUserMedia is not implemented in this browser'),
										);
									}
									return new Promise(function (resolve, reject) {
										getUserMedia.call(navigator, constraints, resolve, reject);
									});
								};
							}

							navigator.mediaDevices
								.getUserMedia({ audio: true })
								.then(function success() {
									toggleMicPermission(true);
									instructionLink();
								})
								.catch(function failure(err) {
									console.log('Mic permissions denied', err);
									setShowPermitMic(true);
									toggleMicPermission(false);
								});
						}
					};

					if (progressbar === 0) {
						instructionText = 'View Course';
					} else {
						instructionText = 'CONTINUE';
					}
					let { revealDate, dateReveal, timeReveal, reveal } = setRevealTimer(
						reveal_date,
						reveal_time,
					);
					reveal_date = dateReveal;
					reveal_time = timeReveal;

					if (!!reveal_date && !!reveal_time) {
						if (
							dateDiff('milliseconds', `${reveal_date} ${reveal_time}`) >
							minToMs(0) &&
							dateDiff('milliseconds', `${reveal_date} ${reveal_time}`) < minToMs(60)
						) {
							let timer = setInterval(function () {
								if (
									dateDiff('milliseconds', `${reveal_date} ${reveal_time}`) <=
									minToMs(0)
								) {
									console.log('reload');
									clearInterval(timer);
									window.location.reload();
								}
							}, 10000);
						}
					}
					return (
						<Zoom key={course_id} className="dash-courses last-dash-course">
							<div className="dash-course-logo">
								<img
									src={Config.STORAGEPATH + 'img/courses/' + course_id + '.png'}
									alt="courseimage"
								/>
							</div>
							<div className="dash-course-decs">
								<p>{element_name}</p>
								<p className="dash-decs-date">
									{/*<strong>{element_description}</strong>*/}
								</p>
								<div className="dash-course-decs-bottom">
									<button
										aria-label={instructionText}
										className="btn btn-primary"
										data-target={instructionLink['data-target']}
										data-toggle={instructionLink['data-toggle']}
										onClick={getPermissions}
										style={{
											pointerEvents: reveal > minToMs(0) ? 'none' : 'auto',
											opacity: reveal > minToMs(0) ? '0.5' : '1',
										}}
									>
										{instructionText}
									</button>
								</div>
								{reveal > minToMs(0) && (
									<p className="dash-decs-date">
										<strong>Activity will be available at: </strong>

										{moment(revealDate).format('D-MM-YYYY HH:mm:ss')}
									</p>
								)}
							</div>
							<TestInstruction />
						</Zoom>
					);
				})
			: null;

	return (
		<div className="course-division">
			<h4>Up Next</h4>
			{upnextAll.length > 0 ? (
				<>
					<ListAnimation open={true}>
						{UpNextCoach}
						{UpNextLive}
						{UpNextOnline}
					</ListAnimation>
				</>
			) : (
				<p>
					Well done! You don't have any pending tasks. You can buy new course{' '}
					<a target="_self" href="/buycourse" className="divAsAnchor">
						here
					</a>
					!
				</p>
			)}
		</div>
	);
};

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(UpnextList),
);
